
export const pceInstruction = '2. Login to MuleSoft Help Center and download the Anypoint Monitoring Installer to your Mule home directory.'
export const defaultInstruction = '2. Download the am.zip to your Mule home directory:'
